<template>
	<div>
		<el-page-header @back="goBack"> </el-page-header>
		<el-container>
			<el-container>
				<el-main style="margin-top: 2rem; padding: .3rem;margin-bottom: 2rem;">
					<el-row>
						<el-col :span='5'></el-col>
						<el-col :span='14'>
							<iframe v-show="ifra" :src='src' width='100%' height='800px'></iframe>
							<div v-show="pdfs" style=" position: relative;height:665px">
								<div  style="width: 98.5%; height: 100%;z-index: 2;position: absolute;top: 0;opacity: 0;"></div>
								<iframe id="fraDisabled" :src='urls' width='100%' height='665px' style="margin-top: -65px;z-index: 1;position: absolute;"></iframe>
							</div>
							<img v-show="imgs" :src="url" width="400px" />
							<el-col :span='24' class="background-color-bai" v-show="mp4">
								<video-player v-show="mp4" ref="videoPlayer" class="video-player vjs-custom-skin" :playsinline="true" :options="playerOptions" @play="onPlayerPlay($event)" @pause="onPlayerPause($event)" />
							</el-col>
						</el-col>
						<el-col :span='5'></el-col>
					</el-row>
				</el-main>
			</el-container>
		</el-container>
	</div>
</template>

<script>
	import pdf from 'vue-pdf'
	import qs from 'qs'
	import 'video.js/dist/video-js.css'
	import 'vue-video-player/src/custom-theme.css'
	import { videoPlayer } from 'vue-video-player'
	import {ResSetDown ,ResSetView,ResK} from '@/api/home'
	export default {
		data() {
			return {
				currentPage: 0, // pdf文件页码
				pageCount: 0, // pdf文件总页数
				fileType: 'pdf', // 文件类型
				src: '', // pdf文件地址
				dats: '',
				url: '',
				urls: '',
				ifra: false,
				imgs: false,
				pdfs: false,
				mp4: false,
				sui: '',
				download: '',
				playerOptions: {
					// playbackRates: [0.7, 1.0, 1.5, 2.0], //播放速度
					autoplay: false, // 如果true,浏览器准备好时开始回放。
					muted: false, // 默认情况下将会消除任何音频。
					loop: false, // 导致视频一结束就重新开始。
					preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
					language: 'zh-CN',
					aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
					fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
					sources: [{
						type: 'video/mp4', // 这里的种类支持很多种：基本视频格式、直播、流媒体等，具体可以参看git网址项目
						src: '' // url地址
					}],
					hls: true,
					poster: '', // 你的封面地址
					width: document.documentElement.clientWidth, // 播放器宽度
					notSupportedMessage: '此视频暂无法播放，请稍后再试', // 允许覆盖Video.js无法播放媒体源时显示的默认信息。
					controlBar: {
						timeDivider: true,
						durationDisplay: true,
						remainingTimeDisplay: false,
						fullscreenToggle: true // 全屏按钮
					}
				},
			}
		},
		components: {
			pdf,
			videoPlayer
		},
		methods: {
			goBack() {
            history.go(-1);
        },
			xia() {

			},
			changePdfPage(val) {
				if(val === 0 && this.currentPage > 1) {
					this.currentPage--
				}
				if(val === 1 && this.currentPage < this.pageCount) {
					this.currentPage++
				}
			},

			// pdf加载时
			loadPdfHandler(e) {
				this.currentPage = 1 // 加载的时候先加载第一页
			},
			onPlayerPlay(player) {
				//				alert("play");
			},
			onPlayerPause(player) {
				//				alert("pause");
			},
			disableContextMenu(){
				window.frames["fraDisabled"].document.oncontextmenu = function() 
         { 
            alert("No way!"); 
            return false;
         };   
			}

		},
		computed: {
//			player() {
//				return this.$refs.videoPlayer.player
//			}
		},
		mounted() {
			let url = this.$route.query.url;
			let that=this
			if(/\.(png|PNG|jpeg|bmp|jpg|webp|gif)$/.test(url)) {
						that.url = url
						that.imgs = true
						that.ifra = false
						that.pdfs = false
						that.mp4 = false
						that.sui = that.url
					} else if(/\.(pdf|PDF)$/.test(url)) {
						that.urls = url
						that.imgs = false
						that.ifra = false
						that.pdfs = true
						that.mp4 = false
						that.sui = that.urls
					} else if(/\.(mp4|mov|mp3|m4a|MP4|MP3|MOV|M4A|m4v|M4V)$/.test(url)) {
						that.playerOptions.sources[0].src = url
						that.imgs = false
						that.ifra = false
						that.pdfs = false
						that.mp4 = true
						that.sui = that.playerOptions.sources[0].src
					} else {
						that.src = 'https://view.officeapps.live.com/op/view.aspx?src=' + url
						that.ifra = true
						that.imgs = false
						that.pdfs = false
						that.mp4 = false
						that.sui = url
					}
		},
	}
</script>

<style>
	.video-js .vjs-big-play-button {
		height: 2em;
		width: 2em;
		line-height: 2em;
		border-radius: 1em;
	}
	.video-js .vjs-modal-dialog {
		border: 1px solid #545454;
	}
	.vjs-custom-skin > .video-js .vjs-big-play-button{
		left: 53%;
	}
	.video-js .vjs-big-play-button {
		border: none;
		background: #dd6058;
	}
	.video-js .vjs-big-play-button .vjs-icon-placeholder:before {
		font-size: 1.5rem;
	}

</style>


// WEBPACK FOOTER //
// src/components/read/pdf.vue